import { IOption } from '@/interfaces/option/option.interface'
import { sortObjectByValue } from '@/utils/sortObjectByValue'

export const sortValues: IOption[] = [
  { value: 'NEWEST', label: 'projectSort.NEWEST' },
  { value: 'OLDEST', label: 'projectSort.OLDEST' },
].sort(sortObjectByValue)
